import styles from "../../styles/shared/ai-trade-suggestion/BacktestHistory.module.css";
import useSuggestedSignal from "../../hooks/useSuggestedSignal";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { getRelativeTime } from "../../utility/formatter-helper";
import { currencyFormatter, formatAmount } from "../../utility/helper";
import { Table } from "antd";

function BacktestHistory({ coin, timeframe, loading = false }) {
  const { liveSuggestionLoading, historyData } = useSuggestedSignal({
    coin,
    timeframe,
    oppositeSignal: "",
  });

  const showLoading = loading || liveSuggestionLoading;

  const [tableData, setTableData] = useState([]);

  const sortedHistory = [...historyData]?.sort((a, b) => {
    return moment(b["Trade Date"], "DD MMM YYYY, HH:mm:ss").diff(
      moment(a["Trade Date"], "DD MMM YYYY, HH:mm:ss"),
    );
  });

  const columns = [
    {
      title: "Signal Time",
      dataIndex: "date",
      key: "date",
      align: "center",
      render: (text) => (
        <span style={{ fontSize: "12px" }}>{getRelativeTime(text)}</span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "center",
      render: (text, record) => {
        const price = record?.entryPrice;
        const isPriceValid = Number(price);

        return (
          <div
            style={{
              fontSize: "12px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span>{formatAmount(text)}</span>

            {isPriceValid && (
              <span style={{ color: "grey", fontSize: "11px" }}>
                {currencyFormatter(text * price)}USDT
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Entry Price",
      dataIndex: "entryPrice",
      key: "entryPrice",
      responsive: ["md"],
      align: "center",
      render: (text) => (
        <span style={{ fontSize: "12px" }}>{currencyFormatter(text)}</span>
      ),
    },
    {
      title: "Exit Time",
      dataIndex: "exitTime",
      key: "exitTime",
      align: "center",
      responsive: ["sm"],
      render: (text) => (
        <span style={{ fontSize: "12px" }}>{getRelativeTime(text)}</span>
      ),
    },
    {
      title: "Exist Price",
      dataIndex: "exitPrice",
      key: "exitPrice",
      responsive: ["md"],
      align: "center",
      render: (text) => (
        <span style={{ fontSize: "12px" }}>{currencyFormatter(text)}</span>
      ),
    },
    {
      title: "P/L (%)",
      dataIndex: "profitLoss",
      key: "profitLoss",
      align: "center",
      render: (text) => (
        <span style={{ color: text?.includes("-") ? "red" : "green" }}>
          {text?.split("%")?.[0]}%
        </span>
      ),
    },
  ];

  useEffect(() => {
    if (!historyData?.length) {
      setTableData((current) => (current.length ? [] : current));
      return;
    }

    setTableData(
      sortedHistory?.map((item, index) => {
        return {
          key: index,
          position: item?.Position,
          asset: item?.["Asset"],
          currency: item?.currency,
          amount: item?.Amount,
          action: item?.trade_type,
          price: item?.trigger_price,
          date: item?.["Trade Date"],
          orderMode: item?.order_mode,
          trader: item?.Trader,
          status: item?.Position,
          info: item,
          entryPrice: item?.["Entry Price"],
          exitPrice: item?.["Exit Price"],
          profitLoss: item?.PnL,
          exitTime: item?.["Last Activity Date"],
        };
      }),
    );
  }, [historyData]);

  return (
    <Table
      className={styles.table}
      columns={columns}
      dataSource={tableData}
      bordered
      loading={showLoading}
      pagination={{ pageSize: 5, position: ["bottomCenter"] }}
      locale={{
        emptyText: (
          <div
            style={{
              textAlign: "center",
              fontStyle: "italic",
              marginBottom: 0,
            }}
          >
            <p>Click "Run AI Backtest" to perform the live backtest.</p>
          </div>
        ),
      }}
    ></Table>
  );
}

export default BacktestHistory;
